import React, { useEffect, useState } from 'react';
// import { userRegister } from '../../actions';
import { Button, Col, Form, Input, Row } from 'antd';
import { useDispatch } from 'react-redux';
import { changePassword, resetPassword } from '../../actions/user';
import { useLocation, useNavigate } from 'react-router-dom';
// @ts-ignore
import { setAuthorizationToken } from '../../auth';
import { getUrlToken } from '@utils/url-hash-params';
import axios from 'axios';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const tailLayout = {
    wrapperCol: { offset: 13, span: 16 },
};

const ChangePasswordForm: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const token = getUrlToken(location?.search)
    const dispatch = useDispatch();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState(null);

    const handlePasswordChange = (e: any) => {
        setPassword(e.target.value);
    };

    const handleConfirmPasswordChange = (e: any) => {
        setConfirmPassword(e.target.value);
    };

    const onFinish = (values: any) => {
        const payload = {
            password: password,
            token: token
        };
        if (password !== confirmPassword) {
            setPasswordError('Passwords do not match');
        } else {
            setPasswordError(null);
            // Submit the form or perform other actions
            dispatch(
                changePassword(payload, (resp: any) => {
                    console.warn('resp :::::::::::::', resp);
                    if (resp) {
                        // navigate('/setup');
                    }
                })
            );
        }

    };

    console.warn("Password ::::::::;", password)

    return (
        <div className='authforms' style={{padding: "152px 60px"}}>
                <div className="authHeadings">
                    <button 
                    onClick={()=> {
                        navigate('/')
                    }} className='btn textAuthHeading'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect x="0.4" y="0.4" width="23.2" height="23.2" rx="11.6" stroke="#F47523" stroke-width="0.8" />
                        <path d="M14 8L10 12L14 16" stroke="#F47523" stroke-width="1.25" stroke-linecap="round" />
                    </svg> </button>
                  
                    <div className="textAuthHeading">Change <span>Password</span></div>
                </div>
            <Row>
                <Col lg={24} md={24} sm={24}>
                    <Form
                        className='formControl'
                        {...layout}
                        form={form}
                        name="email_password_form"
                        onFinish={onFinish}
                        layout="vertical"
                        // onFinishFailed={onFinishFailed}
                        initialValues={{ remember: true }}
                        style={{ maxWidth: '600px', margin: 'auto' }}
                    >
                        <Form.Item className='formControlDesign'  label="Password">
                            <Input.Password
                                value={password}
                                iconRender={(visible) =>
                                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                }
                                onChange={handlePasswordChange}
                                placeholder="Enter password"
                            />
                        </Form.Item>
                        <Form.Item className='formControlDesign' label="Confirm Password">
                            <Input.Password
                                value={confirmPassword}
                                iconRender={(visible) =>
                                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                }
                                onChange={handleConfirmPasswordChange}
                                placeholder="Enter confirm password"
                            />
                        </Form.Item>
                        {passwordError && (
                            <div style={{ color: 'red' }}>{passwordError}</div>
                        )}

                        <Form.Item>
                            <Button className='btn btn-primary w-100' type="primary"  htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </div>
    );
};

export default ChangePasswordForm;
